import React from 'react';
import { number, object } from 'prop-types';
import classNames from 'classnames';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { Tooltip } from '@fiverr-private/fit';
import { getCalculatorTooltip } from '../../../utils/translation/pricingFactors/buyerTooltip';
import { BUYER_REQUESTED_COUNT } from '../../../utils/pricingFactors/constants';
import CalculatorInput from './CalculatorInput';

import './style.scss';

const PackageCalculator = (
    { id, name, currentValue, value, additionalValue, price, packageId },
    { currencyConverter, general: { subCategoryId } }
) => {
    const formInputName = `calculators[${id}][quantity]`;
    const replacements = {
        includedAmount: value,
        additionalAmountStep: additionalValue,
        additionalPriceStep: currencyConverter.convert(price)
    };

    return (
        <I18nProvider>
            {({ i18n }) => (
                <Tooltip className={classNames('package-calculator')}
                    boxContentClassName="tooltip-box-content"
                    appendToBody={false}
                    content={getCalculatorTooltip({ i18n, name, subCategoryId, replacements })}>
                    <CalculatorInput packageId={packageId}
                        initValue={value}
                        currentValue={currentValue}
                        id={id}/>
                    {/* todo: remove BUYER_REQUESTED_COUNT field after BE adjustment */}
                    <input type="hidden" name={BUYER_REQUESTED_COUNT} value={currentValue}/>
                    <input type="hidden" name={formInputName} value={currentValue}/>
                </Tooltip>
            )}
        </I18nProvider>
    );
};

PackageCalculator.propTypes = {
    id: number,
    price: number,
    name: number,
    currentValue: number,
    value: number,
    additionalValue: number,
    packageId: number
}.isRequired;

PackageCalculator.contextTypes = {
    currencyConverter: object,
    general: object
};

export default PackageCalculator;
